module.exports = __webpack_public_path__ + "static/media/ai.5656d673.png";